import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Language List Data
export const fetchLanguageList = createAsyncThunk(
  "language/fetchLanguageList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/panel/LanguageList");
      return response.data; // Adjust based on your API response structure
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Update Language List Data
export const updateLanguageList = createAsyncThunk(
  "language/updateLanguageList",
  async (languageData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/panel/LanguageList", languageData);
      alertSuccess(response.data.success);
      return response.data; // Adjust based on your API response structure
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Add New Language to List
export const addLanguage = createAsyncThunk(
  "language/addLanguage",
  async (newLanguageData, { rejectWithValue }) => {
    try {
      const response = await api.post("/panel/LanguageList", newLanguageData);
      alertSuccess(response.data.success);
      return response.data; // Adjust based on your API response structure
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

const languageSlice = createSlice({
  name: "language",
  initialState: {
    data: null, // Stores the fetched language list data
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null, // Stores error messages
  },
  reducers: {
    clearLanguageList(state) {
      state.data = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetchLanguageList
      .addCase(fetchLanguageList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchLanguageList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchLanguageList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Handle updateLanguageList
      .addCase(updateLanguageList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateLanguageList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = { ...state.languageList, ...action.payload };
      })
      .addCase(updateLanguageList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Handle addLanguage
      .addCase(addLanguage.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addLanguage.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = [...(state.data || []), action.payload];
      })
      .addCase(addLanguage.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearLanguageList } = languageSlice.actions;

export default languageSlice.reducer;
